var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "34",
      "height": "34"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "red"
    }
  }, [_c('path', {
    attrs: {
      "d": "M33 16.75C33 25.725 25.725 33 16.75 33S.5 25.725.5 16.75 7.775.5 16.75.5 33 7.775 33 16.75z"
    }
  }), _c('path', {
    attrs: {
      "stroke-linecap": "round",
      "d": "m11 9.75 12.171 14m0-14L11 23.75"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }